module.exports = __webpack_public_path__ + "img/gBalm3.d665e207.jpg";